export default __webpack_public_path__ + "static/media/prato.5060abe7.png";